export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorEmailAllowedChars = value => {
  if (value === undefined || value === null || value.length === 0) {
    return true
  }

  const emailParts = value.split('@')
  if (emailParts.length !== 2) {
    return false
  }

  const [localPart, domainPart] = emailParts

  const localPartRegExp = /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+$/
  const domainPartRegExp = /^(?:[A-Za-z0-9-]+\.)+[A-Za-z0-9-]+$/

  return localPartRegExp.test(localPart) && domainPartRegExp.test(domainPart)
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorTime = time => {
  const cRegExp = new RegExp('([0-1][0-9]|2[0-3]):([0-5][0-9])')
  return cRegExp.test(time)
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validatorTaxIdentifier = value => {
  if (value === undefined || value === null || value.length === 0) {
    return true
  }

  const sanitizedValue = value.replace(/[\s-]/g, '')

  if (!/^\d{10}$/.test(sanitizedValue)) {
    return false
  }

  const digits = sanitizedValue.split('').map(Number)
  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7]
  const checksum = weights.reduce((sum, weight, index) => sum + (digits[index] * weight), 0) % 11

  if (checksum === 10) {
    return false
  }

  return checksum === digits[9]
}
